import React, { useEffect, useState } from 'react';
import { ArrowRight, Calendar } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="sticky top-0 z-50 px-4 md:px-6 pt-4">
      <header
        className={`max-w-7xl mx-auto flex items-center justify-between h-16 md:h-[68px] px-4 md:px-6 rounded-full transition-all duration-300 ${
          scrolled ? 'bg-white/90 backdrop-blur-md shadow-[0_10px_30px_-15px_rgba(0,0,0,0.12)] border border-neutral-200' : 'bg-white border border-neutral-200'
        }`}
      >
        <a href="#top" onClick={handleNav('top')} className="flex items-center gap-2.5">
          <img
            src="/one-catalyst-logo.png"
            alt="One Catalyst"
            className="h-9 w-9 rounded-[9px] object-contain"
          />
          <span className="font-display-bold text-[18px] md:text-[19px] tracking-tight text-neutral-900">One Catalyst</span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          <a href="#crisis" onClick={handleNav('crisis')} className="nav-link text-[14px] font-medium text-neutral-700">What we solve</a>
          <a href="#how" onClick={handleNav('how')} className="nav-link text-[14px] font-medium text-neutral-700">How it works</a>
          <a href="#pricing" onClick={handleNav('pricing')} className="nav-link text-[14px] font-medium text-neutral-700">Engagement</a>
          <a href="#team" onClick={handleNav('team')} className="nav-link text-[14px] font-medium text-neutral-700">Team</a>
          <a href="#faq" onClick={handleNav('faq')} className="nav-link text-[14px] font-medium text-neutral-700">FAQ</a>
          <a href="#contact" onClick={handleNav('contact')} className="nav-link text-[14px] font-medium text-neutral-700">Contact</a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="https://calendly.com/contact-onecatalyst/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline hidden md:inline-flex items-center gap-2 bg-white text-neutral-900 border border-neutral-900 text-sm font-medium pl-4 pr-4 py-2.5 rounded-full"
          >
            Schedule a Call
          </a>
          <a
            href="https://wa.me/918976171100"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2 bg-neutral-900 text-white text-sm font-medium pl-4 md:pl-5 pr-3 md:pr-4 py-2.5 rounded-full"
          >
            Get in Touch
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </header>
    </div>
  );
}
